import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import TreeRemoval from "../pages/services/tree-removal/page";
import TreeTrimming from "../pages/services/tree-trimming/page";
import StumpGrinding from "../pages/services/stump-grinding/page";
import ServiceAreas from "../pages/service-areas/page";
import Reviews from "../pages/reviews/page";
import FAQ from "../pages/faq/page";
import Contact from "../pages/contact/page";
import Gallery from "../pages/gallery/page";
import Process from "../pages/process/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/services", element: <Services /> },
  { path: "/services/tree-removal", element: <TreeRemoval /> },
  { path: "/services/tree-trimming", element: <TreeTrimming /> },
  { path: "/services/stump-grinding", element: <StumpGrinding /> },
  { path: "/service-areas", element: <ServiceAreas /> },
  { path: "/reviews", element: <Reviews /> },
  { path: "/faq", element: <FAQ /> },
  { path: "/contact", element: <Contact /> },
  { path: "/gallery", element: <Gallery /> },
  { path: "/process", element: <Process /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
